/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { skipAutoDateConversion } from '../../../api-dates';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ServerInfoDto as PlatformServerInfoDto } from '../../models/platform/server-info-dto';

export interface GetInfo$Params {
}

export function getInfo(http: HttpClient, rootUrl: string, params?: GetInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformServerInfoDto>> {
  const rb = new RequestBuilder(rootUrl, getInfo.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context: skipAutoDateConversion(context) })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformServerInfoDto>;
    })
  );
}

getInfo.PATH = '/info';

